import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { backendEndPointToken } from './app.config';
import { switchMap } from 'rxjs';
import { StateService } from './shared/state.service';
import { ErrorService } from './shared/error.service';
import { DisableSortParam } from './loading.interceptor';
import { SuccessToastService } from './shared/success-toast.service';

@Injectable({
  providedIn: 'root'
})
export class StatusChangesService {
  bigStatusOptionsByResources = {
    ChargeItemDefinition: 'draft | active | retired | unknown'.split(' | '),
    Medication: 'active | inactive | entered-in-error'.split(' | ')
  }
  http = inject(HttpClient);
  backendApiBaseUrl = inject(backendEndPointToken);
  constructor() { }
  changeStatus(resourceType: string, resourcesToPopulate: 'org' | 'patient', id: string, status: string) {
    this.http.get(`${this.backendApiBaseUrl}/${resourceType}/${id}`, {
      context: new HttpContext().set(DisableSortParam, true)
    }).pipe(
      switchMap((e: any) => {
        e.status = status;
        return this.http.put(`${this.backendApiBaseUrl}/${resourceType}/${id}`, e, {
          headers: {
            'Content-Type': 'application/fhir+json',
            'Prefer': 'return=representation'
          }
        })
      })
    ).subscribe({
      next: (res: any) => {
        console.log('Status changed successfully', res);
        this.successToast.success(`${resourceType} status updated to "${status}".`);
// $#$        // /* alert(resourcesToPopulate) */
        if (resourcesToPopulate === 'org') {
          this.stateService.persistOrgWideResource(res, 'saved');
        } else {
          this.stateService.persistPatientResource(res, 'saved');
        }
      },
      error: (err) => {
        this.errorService.openandCloseError('Error changing status');

      }
    });
  }
  stateService = inject(StateService);
  errorService = inject(ErrorService)
  successToast = inject(SuccessToastService);
}
